<template>
	<div class="tongjixinxi">
		<div class="tongji">
			<Tag size="large" color="orange">总金额:{{map.yearMoney/100}}元</Tag>
			<Tag size="large" color="orange">退款金额:{{map.yearMoneyRefund/100}}元</Tag>
			<Tag size="large" color="green">微信:{{map.wechatYearMoney/100}}元</Tag>
			<Tag size="large" color="green">微信退款:{{map.wechatYearMoneyRefund/100}}元</Tag>
			<Tag size="large" color="cyan">支付宝:{{map.aliapyYearMoney/100}}元</Tag>
			<Tag size="large" color="cyan">支付宝退款:{{map.aliapyYearMoneyRefund/100}}元</Tag>
			<Tag size="large" color="blue">环保积分:{{map.xiaojieYearMoney/100}}元</Tag>
			<Tag size="large" color="blue">环保积分退款:{{map.xiaojieYearMoneyRefund/100}}元</Tag>
			<!-- <Tag size="large" color="geekblue">小善积分:{{map.xiaoshanMoney}}元</Tag>
			<Tag size="large" color="geekblue">小善积分退款:{{map.xiaoshanRefundMoney}}元</Tag> -->
		
		</div>
		<!-- <div class="tongji tongji-dingbu">
			<div class="item1">

			</div>
			<div class="item">
				总金额（元）
			</div>
			<div class="item">
				实际金额
			</div>
			<div class="item">
				退款金额
			</div>
		</div>
		<div class="tongji">
			<div class="item1" style="background-color: #F24343;">
				总计
			</div>
			<div class="item">
				<div class="item-title2">{{map.yearMoney/100}}元</div>
			</div>

			<div class="item">
				<div class="item-title2">{{map.yearMoney2/100}}元</div>
			</div>

			<div class="item">
				<div class="item-title2">{{map.yearMoneyRefund/100}}元</div>
			</div>
		</div>
		<div class="tongji">
			<div class="item1"  style="background-color: #A6EC00;">
				微信
			</div>
			<div class="item">
				<div class="item-title2">{{map.wechatYearMoney/100}}元</div>
			</div>

			<div class="item">
				<div class="item-title2">{{map.wechatYearMoney2/100}}元</div>
			</div>

			<div class="item">
				<div class="item-title2">{{map.wechatYearMoneyRefund/100}}元</div>
			</div>
		</div>

		<div class="tongji">
			<div class="item1" style="background-color: #61E4FF;">
				支付宝
			</div>
			<div class="item">
				<div class="item-title2">{{map.aliapyYearMoney/100}}元</div>
			</div>
			<div class="item">
				<div class="item-title2">{{map.aliapyYearMoney2/100}}元</div>
			</div>

			<div class="item">
				<div class="item-title2">{{map.aliapyYearMoneyRefund/100}}元</div>
			</div>
		</div>

		<div class="tongji">
			<div class="item1" style="background-color: #2FC6E8;">
				环保积分
			</div>
			<div class="item">
				<div class="item-title2">{{map.xiaojieYearMoney/100}}元</div>
			</div>
			<div class="item">
				<div class="item-title2">{{map.xiaojieYearMoney2/100}}元</div>
			</div>

			<div class="item">
				<div class="item-title2">{{map.xiaojieYearMoneyRefund/100}}元</div>
			</div>
		</div> -->

	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		props:['map']
		
	}
</script>

<style scoped="scoped" lang="less">
	.tongjixinxi{
		width: 100%;
		
		.tongji {
			width: 100%;
			display: flex;
		
		}
		.tongji-dingbu{
			background-color: #FFFFFF;
			height: 30px;
			color: #333333;
			font-weight: 700;
		}
		
	}
</style>



// WEBPACK FOOTER //
// src/components/comm/tongji.vue